import React from 'react';

import styled from '@emotion/styled';

import { paymentLinkActions } from '../../redux/slices/paymentLinkSlice';
import { useAppDisPatch } from '../../redux/store';
import CancelIcon from '../Icons/CancelIcon';

interface PaystackIframeProps {
  paymentLink: string;
}

const PaystackIframe: React.FC<PaystackIframeProps> = ({ paymentLink }) => {
  const dispatch = useAppDisPatch();
  const handleCancelPaystackPopUp = (event: any) => {
    dispatch(paymentLinkActions.setPaymentLink({ paymentLink: undefined }));
  };

  return (
    <Container>
      <Iframe
        src={paymentLink}
        title='Paystack Payment'
        frameBorder='0'
        allowFullScreen
      ></Iframe>
      <IconContainer onClick={handleCancelPaystackPopUp}>
        <CancelIcon />
      </IconContainer>
    </Container>
  );
};

export default PaystackIframe;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: grid;
  justify-content: center;

  & > * {
    grid-column: 1;
    grid-row: 1;
    /* border-radius: 4px; */
  }
`;

const Iframe = styled.iframe`
  width: 535px;
  height: 100%;
  /* border: 2px solid red; */
`;

const IconContainer = styled.div`
  margin-top: 90px;
  margin-left: auto;
  cursor: pointer;

  & > svg {
    transform: scale(100%);
    transition: transform 0.3s ease-out;

    &:hover {
      transform: scale(110%);
    }
  }
`;
